var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-occ-c30": "",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-occ-c30": "",
    d: "M6.0004 0.753785C3.14183 0.754675 0.753572 3.14601 0.753586 6.00223C0.75359 7.03196 1.06007 8.04915 1.63208 8.90908L0.751953 11.2507L3.69916 10.7177C4.4191 11.0696 5.20965 11.2459 6.0004 11.2464C8.86145 11.2484 11.2519 8.86022 11.2519 6.00223C11.2519 3.14751 8.86059 0.752097 6.0004 0.753785Z",
    stroke: "#39BC58",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "_ngcontent-occ-c30": "",
    d: "M7.69179 6.70761C7.82798 6.75726 8.55846 7.11648 8.70703 7.19101C8.8556 7.26542 8.95482 7.30264 8.99196 7.36459C9.0291 7.42654 9.02918 7.72409 8.90533 8.07113C8.78148 8.41817 8.1879 8.73494 7.90244 8.77759C7.64645 8.81585 7.32272 8.83184 6.96662 8.71871C6.75084 8.65026 6.47407 8.55896 6.11958 8.40575C4.6289 7.76215 3.65552 6.26144 3.58128 6.16227L3.57992 6.16046C3.50078 6.05477 2.97461 5.35213 2.97461 4.62521C2.97461 3.89399 3.35846 3.5344 3.49465 3.38575C3.63084 3.2371 3.79179 3.19983 3.89084 3.19983C3.98989 3.19983 4.08906 3.20091 4.1756 3.20505C4.26682 3.20968 4.38931 3.17026 4.50993 3.46012C4.63374 3.75763 4.93076 4.48898 4.96803 4.56335C5.00529 4.63772 5.02997 4.72455 4.98045 4.82364C4.93092 4.92273 4.90616 4.98476 4.83188 5.07151C4.75759 5.15826 4.67585 5.26521 4.60898 5.3318C4.53461 5.40592 4.45718 5.48625 4.54384 5.63503C4.63051 5.7838 4.92869 6.27031 5.37039 6.6643C5.93767 7.17051 6.41664 7.32774 6.56517 7.40202C6.7137 7.47631 6.80032 7.46393 6.88703 7.36476C6.97374 7.26558 7.25846 6.93122 7.35751 6.78215C7.45656 6.63308 7.5556 6.65797 7.69179 6.70761Z",
    fill: "#39BC58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsap);
export default __webpack_public_path__ + "static/media/whatsap.df5ddecc6dcddec6f6ccec842abb9bb7.svg";
export { ForwardRef as ReactComponent };